module.exports = __webpack_public_path__ + "img/23.86f69918.jpg";